import { DEFAULT_LANGUAGE_CODE, SUPPORTED_LANGUAGE_CODES } from "./constants"

export function transformLocaleToLanguageCode(locale: string) {
  const languageCode = locale.split("-")?.[0]

  return languageCode && SUPPORTED_LANGUAGE_CODES.includes(languageCode)
    ? languageCode
    : DEFAULT_LANGUAGE_CODE
}
